export const randomColors = [
  'bg-red-100',
  'bg-blue-200',
  'bg-purple-200',
  'badge-success',
  'badge-warning',
  'badge-error',
  'badge-outline',
]
